module.exports = __webpack_public_path__ + "static/img-main-64a874d9e5d1cd9c04929c780cf581d3.png";